var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),(_vm.text)?_c('p',{staticClass:"mt-6 text--sm"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }